import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { PatientAddress } from '../../../../core/models/patient/patientAddress';

@Component({
  selector: 'app-profile-address-info',
  templateUrl: './profile-address-info.component.html',
  styleUrls: ['./profile-address-info.component.scss']
})
export class ProfileAddressInfoComponent implements OnInit, OnChanges {

  @Input() isParams = false;
  @Input() addresses: PatientAddress[];
  @Output() toggleEditEvent = new EventEmitter();
  homeAddress: PatientAddress;
  previousAddress: PatientAddress;
  mailAddress: PatientAddress;
  billingAddress: PatientAddress;

  billAddressSameAsMailing = false;
  billAddressSameAsHome = false;
  mailAddressSameAsHome = false;

  constructor() { }

  ngOnInit() {
  }
  ngOnChanges() {
    this.populateAddresses();
  }

  toggleEdit() {
    this.toggleEditEvent.emit();
  }
  populateAddresses() {
    if (this.addresses && this.addresses.length > 0) {
      if (this.addresses && this.addresses.length > 0) {
        this.addresses = this.addresses.filter(x => x.active);
        for (let i = 0; i < this.addresses.length; i++) {
          const value = this.addresses[i];
          if (value.type == 'HOME') {
            this.homeAddress = value;
            if (value.isMailing) {
              this.mailAddressSameAsHome = true;
              this.mailAddress = { ...this.homeAddress };
            }
            if (value.isBilling) {
              this.billAddressSameAsHome = true;
              this.billAddressSameAsMailing = false;
              this.billingAddress = { ...this.homeAddress };
            }
          }
          else if (value.type == 'MAILING') {
            this.mailAddress = value;
            if (value.isBilling) {
              this.billAddressSameAsMailing = true;
              this.billingAddress = { ...this.mailAddress };
            }
          }
          else if (value.type == 'BILLING') {
            this.billingAddress = value;
          }
        }
      }
    }
  }
}
